import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../Button';
import { WidgetSize } from './WidgetSize.type';

export interface CountdownWidgetStateStartedProps {
  isThin?: boolean;
  size?: WidgetSize;
  handleJoinClick: () => void;
}

export const CountdownWidgetStateStarted = ({
  isThin,
  size,
  handleJoinClick,
}: CountdownWidgetStateStartedProps) => {
  const __ = useTranslation().t;

  const title = __('theTeacherIsWaiting');
  const subtitle = __('classStarting');
  const btnText = __('joinClass');

  if (size === 'sm') {
    return (
      <BannerContainer>
        <BannerTextContainer>
          <Title sm>{title}</Title>
          <Subtitle sm>{subtitle}</Subtitle>
        </BannerTextContainer>
        <Button label={btnText} onClick={handleJoinClick} isPulsing size="sm" />
      </BannerContainer>
    );
  }

  return (
    <Container>
      <Title>{title}</Title>
      {!isThin && <StyledHr />}
      <Subtitle isThin={isThin}>{subtitle}</Subtitle>
      <ButtonWrapper>
        <Button label={btnText} onClick={handleJoinClick} isPulsing />
      </ButtonWrapper>
    </Container>
  );
};

interface TitleProps {
  sm?: boolean;
}

const Title = styled.h6<TitleProps>`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dark};

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 10px;
        line-height: 12px;
      }
  `
      : ``}
`;

const StyledHr = styled.hr`
  margin: 12px 0;
  border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
`;

interface SubtitleProps {
  isThin?: boolean;
  sm?: boolean;
}

const Subtitle = styled.p<SubtitleProps>`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #444444;
  ${({ sm }) => (sm ? `` : `margin-bottom: 12px !important;`)}
  margin-top: ${({ isThin }) => (isThin ? 4 : 0)}px;

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 14px;
        line-height: 20px;
      }
  `
      : ``}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  text-align: center;
`;

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 410px;
  margin: auto;
`;

const BannerTextContainer = styled.div`
  flex: 1;
`;
